import React from 'react';
import { Check } from 'lucide-react';
const includes = ['Anatomical focus for every week', 'Peak poses professionally sequenced', 'A weekly philosophical theme', '52 weeks — never repeat yourself'];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 What's inside the Yoga Ready 6-in-1 Bundle?
          </h2>
        </div>

        {/* The Main System */}
        <div className="bg-bg-main rounded-3xl p-8 sm:p-12 border-2 border-primary shadow-lg relative" data-id="element-5">
          <span className="inline-block bg-primary text-white font-bold text-xs sm:text-sm px-5 py-2 rounded-full uppercase tracking-wider mb-6" data-id="element-6">
            The Main System
          </span>

          <div className="flex flex-col sm:flex-row sm:items-start gap-6" data-id="element-7">
            <div className="text-5xl sm:text-6xl flex-shrink-0" data-id="element-8">📅</div>
            <div data-id="element-9">
              <h3 className="text-2xl sm:text-3xl font-serif font-black text-text-main mb-4" data-id="element-10">
                The 52-Week Professional Curriculum
              </h3>
              <p className="text-text-sec text-base sm:text-lg leading-relaxed mb-6" data-id="element-11">
                A complete annual roadmap. 52 weeks of professionally sequenced
                classes, including anatomical focus, peak poses, and
                philosophical themes. Everything you need to teach for a full
                year without ever repeating yourself.
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-12">
                {includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-text-main font-medium text-sm sm:text-base" data-id="element-13">
                    <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-14" />
                    <span data-id="element-15">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}